import { cliente } from './api'

export default {
  Autenticar() {
    const autenticarRequest = {
      usuario: process.env.VUE_APP_CREDIGITAL_USUARIO,
      contrasena: process.env.VUE_APP_CREDIGITAL_CONTRASENA,
    }
    return cliente.post('Login/autenticar', autenticarRequest)
  },
  Ping() {
    return cliente.get('Login/ping')
  },
}
